module.exports = __webpack_public_path__ + "static/NearbyIcon-444a6e5ca09364ee41a5954720141f61.png";